import { Application } from "@hotwired/stimulus"

// Start Stimulus application
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

//
// Register all stimulus controllers below...
//

// ColorModeSwitcherController
import ColorModeSwitcherController from "./color_mode_switcher_controller.js"
application.register("color-mode-switcher", ColorModeSwitcherController)

// NestedForm
import NestedForm from "./nested_form_controller.js"
application.register("nested-form", NestedForm)

// Autocomplete
import AutocompleteController from "./autocomplete_controller.js"
application.register("autocomplete", AutocompleteController)

// StickybarController
import StickybarController from "./stickybar_controller.js"
application.register("stickybar", StickybarController)

//
// DoiRegistration
//

// DoiRegistration/Creator
import DoiRegistrationCreator from "./doi_registration/creator_controller.js"
application.register("doi-registration--creator", DoiRegistrationCreator)

// RORLookup
import DoiRegistrationRORLookup from "./doi_registration/ror_lookup_controller.js"
application.register("doi-registration--ror-lookup", DoiRegistrationRORLookup)
